export const mockContentDelivery = [
  {
    generated_date: "2025-02-18T17:17:49.583Z",
    id: "cm79k8fhk01sx1rn8cm741dfb",
    description: null,
    title: "test",
    url: null,
    viewmodel_type: "list_type",
    children: [
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0u3niwa3qlwi6p716xqjiil",
        description:
          "Use a computational representation to illustrate the relationships among Earth systems and how those relationships are being modified due to human activity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-ESS3-6",
          number_prefix_enhanced: "SCI.HS-ESS3-6",
        },
        title: "HS-ESS3-6",
        url: null,
        viewmodel_type: "list_item",
      },
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0txtv5s19lti6p7wbcug9jf",
        description:
          "Construct an explanation based on evidence for how the availability of natural resources, occurrence of natural hazards, and changes in climate have influenced human activity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-ESS3-1",
          number_prefix_enhanced: "SCI.HS-ESS3-1",
        },
        title: "HS-ESS3-1",
        url: null,
        viewmodel_type: "list_item",
      },
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0u9do5566o0i6p7b9puuxtk",
        description:
          "Evaluate the evidence supporting claims that changes in environmental conditions may result in: (1) increases in the number of individuals of some species, (2) the emergence of new species over time, and (3) the extinction of other species.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-LS4-5",
          number_prefix_enhanced: "SCI.HS-LS4-5",
        },
        title: "HS-LS4-5",
        url: null,
        viewmodel_type: "list_item",
      },
    ],
  },
  {
    generated_date: "2025-02-18T17:17:49.583Z",
    id: "cm7awwd8r00000xok8n1gbu17",
    description: null,
    title: "test standard",
    url: null,
    viewmodel_type: "list_type",
    children: [
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0tvu44e0etri6p7iki5p6cv",
        description:
          "Design, evaluate, and refine a solution for reducing the impacts of human activities on the environment and biodiversity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-LS2-7",
          number_prefix_enhanced: "SCI.HS-LS2-7",
        },
        title: "HS-LS2-7",
        url: null,
        viewmodel_type: "list_item",
      },
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0txtv5s19lti6p7wbcug9jf",
        description:
          "Construct an explanation based on evidence for how the availability of natural resources, occurrence of natural hazards, and changes in climate have influenced human activity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-ESS3-1",
          number_prefix_enhanced: "SCI.HS-ESS3-1",
        },
        title: "HS-ESS3-1",
        url: null,
        viewmodel_type: "list_item",
      },
    ],
  },
  {
    generated_date: "2025-02-18T17:17:49.583Z",
    id: "cm7axkaky00020ypojnbrh915",
    description: null,
    title: "teste 2",
    url: null,
    viewmodel_type: "list_type",
    children: [
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0tvu44e0etri6p7iki5p6cv",
        description:
          "Design, evaluate, and refine a solution for reducing the impacts of human activities on the environment and biodiversity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-LS2-7",
          number_prefix_enhanced: "SCI.HS-LS2-7",
        },
        title: "HS-LS2-7",
        url: null,
        viewmodel_type: "list_item",
      },
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0txtv5s19lti6p7wbcug9jf",
        description:
          "Construct an explanation based on evidence for how the availability of natural resources, occurrence of natural hazards, and changes in climate have influenced human activity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-ESS3-1",
          number_prefix_enhanced: "SCI.HS-ESS3-1",
        },
        title: "HS-ESS3-1",
        url: null,
        viewmodel_type: "list_item",
      },
    ],
  },
  {
    generated_date: "2025-02-18T17:18:18.847Z",
    id: "cm7b1jctr00020tpofzs6kq91",
    description: null,
    title: "test 1",
    url: null,
    viewmodel_type: "list_type",
    children: [
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0tvu44e0etri6p7iki5p6cv",
        description:
          "Design, evaluate, and refine a solution for reducing the impacts of human activities on the environment and biodiversity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-LS2-7",
          number_prefix_enhanced: "SCI.HS-LS2-7",
        },
        title: "HS-LS2-7",
        url: null,
        viewmodel_type: "list_item",
      },
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0txtv5s19lti6p7wbcug9jf",
        description:
          "Construct an explanation based on evidence for how the availability of natural resources, occurrence of natural hazards, and changes in climate have influenced human activity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-ESS3-1",
          number_prefix_enhanced: "SCI.HS-ESS3-1",
        },
        title: "HS-ESS3-1",
        url: null,
        viewmodel_type: "list_item",
      },
    ],
  },
  {
    generated_date: "2025-02-18T17:17:49.583Z",
    id: "cm79fy2cx05dgj0o8lqcfw6gv",
    description: null,
    title: "",
    url: null,
    viewmodel_type: "list_type",
    children: [
      {
        generated_date: "2025-02-18T17:17:49.583Z",
        id: "ck0tvu44e0etri6p7iki5p6cv",
        description:
          "Design, evaluate, and refine a solution for reducing the impacts of human activities on the environment and biodiversity.",
        images: [],
        metadata: {
          content_type: "STANDARD",
          document_adopt_year: "2014",
          document_primary_subject: "",
          grades: ["9", "10", "11", "12"],
          region_codes: ["US", "DE"],
          number_enhanced: "HS-LS2-7",
          number_prefix_enhanced: "SCI.HS-LS2-7",
        },
        title: "HS-LS2-7",
        url: null,
        viewmodel_type: "list_item",
      },
    ],
  },
];
